import { z } from 'zod'

export const ThreadRoutingTypeSchema = z.enum(['handover', 'conversation_routing']).nullable()
